export default __webpack_public_path__ + "static/why-i-run-square-8eb96bb39d0c8376674b6ec2f020e6c4.png";